import { InstanceFactory, PageLibraryFactory } from "@amzn/ask-legal-domain";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { SherpaFooter } from "../../components/layout/SherpaFooter";
import { SherpaHeader } from "../../components/layout/SherpaHeader";
import { PageLive } from "./PageLive";
import { PagePortal } from "./PagePortal";
import useRoutedParamsWithContext from "../../setup/useRoutedParamsWithContext";
import { HomeBreadcrumbWrapper } from "../../components/breadcrumb/HomeBreadcrumbWrapper";
import { PageLiveBreadcrumb } from "../../components/breadcrumb/PageLiveBreadcrumb";

const PagePortalRoute = () => {
    const { pageId } = useRoutedParamsWithContext();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    return <PagePortal id={pageId!} activeTabId={tab || undefined} />;
};

const PageLiveRoute = () => {
    const { pageId } = useRoutedParamsWithContext();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    if (params.has("version")) {
        const version = JSON.parse(params.get("version"));
        return <PageLive id={pageId} version={version} />;
    }
    return <PageLive id={pageId!} />;
};

export const pageRoutes = [
    {
        path: "/page/:pageId/admin",
        content: <PagePortalRoute />,
        breadcrumbs: () => {
            const { pageId } = useRoutedParamsWithContext();
            return <HomeBreadcrumbWrapper items={[
                { text: "Instance Admin Portal", href: `#/instance/${InstanceFactory.fromEntityId(pageId!)}/admin` },
                { text: "Page Library Admin Portal", href: `#/page-library/${PageLibraryFactory.fromEntityId(pageId!)}/admin` },
                { text: "Page Admin Portal", href: `#/page/${pageId}/admin` }
            ]} />;
        },
        header: () => {
            const { pageId } = useRoutedParamsWithContext();
            const instanceId = InstanceFactory.fromEntityId(pageId!);
            return <SherpaHeader headerType="Other" instanceId={instanceId} />;
        },
        footer: () => {
            const { pageId } = useRoutedParamsWithContext();
            return <SherpaFooter variant="AdminPortal" entityId={pageId!} />;
        }
    },
    {
        path: "/page/:pageId/live",
        content: <PageLiveRoute />,
        breadcrumbs: () => {
            const { pageId } = useRoutedParamsWithContext();
            return <PageLiveBreadcrumb pageId={pageId!} />;
        },
        header: () => {
            const { pageId } = useRoutedParamsWithContext();
            const instanceId = InstanceFactory.fromEntityId(pageId!);
            return <SherpaHeader headerType="LivePage" instanceId={instanceId} />;
        },
        footer: () => {
            const { pageId } = useRoutedParamsWithContext();
            return <SherpaFooter variant="LivePage" entityId={pageId!} />;
        }
    }
];
